import { ProcesarDatosApi } from "../api/ApiFetch";
const controladorTecnologia = "procesos";

export const ObtenerPorVacanteUsuario = async (data) => {
    const url = `${controladorTecnologia}/ObtenerPorVacanteUsuario/${data.vacante}/${data.usuario}`;
    return await ProcesarDatosApi('GET', url);
}

export const ObtenerProcesosCompleto = async () => {
    const url = `${controladorTecnologia}/ObtenerProcesosCompleto`;
    return await ProcesarDatosApi('GET', url);
}

export const AgregarProcesos = async (data) => {
    const url = `${controladorTecnologia}/AgregarProcesos`;
    return await ProcesarDatosApi('POST', url, data);
}

export const CambiarPrioridad = async (data) => {
    const url = `${controladorTecnologia}/CambiarPrioridad`;
    return await ProcesarDatosApi('POST', url, data);
}

export const EditarProcesoPersona = async (data) => {
    const url = `${controladorTecnologia}/EditarProceso`;
    return await ProcesarDatosApi('PUT', url, data);
}